<div id="custodia-derivativos" *ngIf="rows.length > 0">
    <mat-expansion-panel>
        <mat-expansion-panel-header>                                  
            <mat-panel-title class="titulo-painel-custodia">                
                <div style="float: left;">
                    <span>OPÇÕES FLEXÍVEIS</span> <br />
                </div>  
                <div class="cor_estrategia"></div>
            </mat-panel-title>
            <mat-panel-description>
                <span class="texto-estrategia">
                    <span>Valor Total:</span><br />
                    <span><b>R$ {{ total_financeiro_atual | number : '1.2-2'}}</b></span> 
                </span>
            </mat-panel-description>
        </mat-expansion-panel-header>
        
        <ng-template matExpansionPanelContent>
            <ngx-datatable 
                #tableAtivo
                class='material'                             
                [loadingIndicator]="loadingListaAtivo"
                [columns]="columns" 
                [columnMode]="'force'" 
                [headerHeight]="50"
                [footerHeight]="50"                                                      
                [rowHeight]="'auto'"
                [rows]='rows'
            >        

                <ngx-datatable-column name="Data Exercício" prop="data_compra" [sortable]="false">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        {{row.data_exercicio | date:'dd/MM/yyyy'}}
                    </ng-template>
                </ngx-datatable-column>            
            
                <ngx-datatable-column name="ATIVO" prop="ativo" [sortable]="true">
                    <ng-template  let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>
                        <span 
                            style="padding: 5px; border-radius: 10px;"
                            [className]="row.cor_hexadecimal" 
                        >
                            <b>{{row.ativo}}</b>
                        </span>   
                    </ng-template>
                </ngx-datatable-column>
            
                <ngx-datatable-column name="Quantidade" prop="qtd" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>                        
                        <span >
                            {{ row.quantidade | number : '1.0-0'}} 
                        </span>
                    </ng-template>
                </ngx-datatable-column>      
                
                <ngx-datatable-column name="Tipo Opção" prop="tipo_opcao" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>                        
                        <span >
                            {{ row.tipo_opcao }}
                        </span>
                    </ng-template>
                </ngx-datatable-column>
            
                <ngx-datatable-column name="Prêmio" prop="preco_executado" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>                                                    
                    <span [ngClass]="{ 'nao-migrado': row.migrado == false }">
                        R$ {{ row.preco_executado | number : '1.2-2'}}
                    </span>
                    </ng-template>
                </ngx-datatable-column>                

                <ngx-datatable-column name="Striker" prop="valor_striker" [sortable]="true">
                    <ng-template let-rowIndex="rowIndex" let-row="row" ngx-datatable-cell-template>                                                    
                    <span [ngClass]="{ 'nao-migrado': row.migrado == false }">
                        R$ {{ row.valor_striker | number : '1.2-2'}}
                    </span>
                    </ng-template>
                </ngx-datatable-column>
            
                <ngx-datatable-column 
                    name="Financeiro (R$)" 
                    prop="volume_financeiro"         
                    [sortable]="true"
                >
                    <ng-template let-rowIndex="rowIndex" let-volume_financeiro="value" ngx-datatable-cell-template>
                        <span>
                            R$ {{ volume_financeiro | number : '1.2-2'}}
                        </span>                                                    
                    </ng-template>
                </ngx-datatable-column>
            
            </ngx-datatable>
        </ng-template>
    </mat-expansion-panel>
</div>
